const HAS_DIGIT = /\d/

/** Unit / flat tokens, so "Vintervägen Lgh 1901" is not treated as a street number. */
const APARTMENT_UNIT =
    /\b(?:lgh|lägenhet|apt\.?|apartment|flat|unit|ste\.?|suite|#)\s*[\d][\w-]*/gi

/**
 * True when the line has a house number, not only an apartment / unit reference.
 */
export const hasStreetNumber = (line: string): boolean => {
    const withoutApartment = line.replace(APARTMENT_UNIT, " ")
    APARTMENT_UNIT.lastIndex = 0
    return HAS_DIGIT.test(withoutApartment)
}
